<ul class="layout-topbar-items" *ngIf="!isMobileScreen">
  <li
    *ngFor="
      let counter of counters$ | async;
      let isLast = last;
      trackBy: trackByFn
    "
    class="layout-topbar-item notifications !border-x-0"
  >
    <app-counter-widget-item [counter]="counter"></app-counter-widget-item>
  </li>
</ul>
<ng-container *ngIf="isMobileScreen">
  <div
    class="layout-topbar-item notifications"
    *ngFor="let counter of counters$ | async; let i = index; trackBy: trackByFn"
  >
    <app-counter-widget-item [counter]="counter"></app-counter-widget-item>
  </div>
</ng-container>
